import React, { useEffect, useRef, useState } from "react";
import {Users } from "lucide-react";
import AccordionItem from "../Elements/AccordionItem";
import QuotaOrganization from "./QuotaOrganization";
import BaseCard from "../Elements/BaseCard";
import QuotaProject from "./QuotaProject";
import QuotaUser from "./QuotaUser";
import { QuotaUserGroup } from "./QuotaUserGroup";
import { useUser } from "@/app/context/UserContext";
import { iQuotaConfig } from "@/app/models/interfaceQuotaConfiguration";
import { iResponse } from "@/app/models/interfaceResponse";
import { chatBotProjectQuotaConfig } from "@/app/services/chatBotProjectQuotaConfig";
import { AlertType } from "@/app/constants/enums";

export default function QuotaConfiguration() {
  const [openItems, setOpenItems] = useState<Record<number, boolean>>({
    0: true,
    1: false,
    });
    const { user, setUser, userProject, setUserProject, addAlert , userLoginInfo,setUserLoginInfo,userProjectLoaded} = useUser();
  
   const fetchQuotaConfig = async () => {
      const defaultQuotaConfig: iQuotaConfig = {
          domain_quota: 0,
          total_quota_project_domain:0,
          group_user_quota: null,
          project_group_user_quota: null,
          project_quota: 0,
          project_user_quota: 0,
          user_quota: 0,
      };
        try {
            const request = {
                domain: userLoginInfo.domain, //--"intercorp.com.pe",//user.email.split("@")[1] || "",
                project_id: userProject?.project.id ?? "",
                user: user.email,
            };  
            const response: iResponse = await chatBotProjectQuotaConfig(request);
            //console.log("response",response)
            if (response.success && response.data) {
                const quotaData = response.data as iQuotaConfig; 
                setUserProject((prev: any) => ({
                        ...prev,
                        project: {
                        ...prev.project,
                        quota_project_domain: quotaData.total_quota_project_domain??0,
                        quota_config: quotaData ?? defaultQuotaConfig,
                        quota: quotaData?.project_quota ?? 0,
                    },
                }));
            } else { 
                setUserProject((prev: any) => ({
                    ...prev,
                    project: {
                    ...prev.project,
                    quota_project_domain: 0,  
                    quota_config: defaultQuotaConfig
                    },
            }));
                addAlert("No se encontraron datos de cuotas, se aplicaron valores por defecto.", AlertType.Warning);
            }
        } catch (error) { 
            setUserProject((prev: any) => ({
                ...prev,
                project: {
                    ...prev.project,
                    quota_project_domain: 0,  
                    quota_config: defaultQuotaConfig,
                },
            }));
            addAlert("Error al consultar cuotas, usando valores por defecto.", AlertType.Error);
            }
    };
    
    useEffect(() => {
      if(userProject.project.quota_config === undefined && userLoginInfo?.domain){
        fetchQuotaConfig();
      } 
    }, [userProject.project.id, userLoginInfo?.domain]); 
     

  const toggleItem = (index: number) => {
    setOpenItems((prev) => ({
      ...prev,
      [index]: !prev[index],
    }));
  };

  return (
    <div className="max-w-4xl mx-auto p-6 pt-0">
      <h1 className="text-lg font-bold text-left">Configuración de Cuotas</h1>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
            <BaseCard>
                <QuotaOrganization />
            </BaseCard>
            
            <BaseCard>
                <QuotaProject />
            </BaseCard> 
        </div>
      

      <AccordionItem
        title="Usuario con cuota"
        index={0}
        isOpen={!!openItems[0]}
        onClick={() => toggleItem(0)}
        className="mb-3"
        classNameHead=""
        icon={<Users className="w-5 h-5 text-blue-400" strokeWidth={1} />}
      >
        <QuotaUser />
      </AccordionItem>

      <AccordionItem
        title="Grupos de Usuario"
        index={1}
        isOpen={!!openItems[1]}
        onClick={() => toggleItem(1)}
        className="mb-3"
        classNameHead=""
        icon={<Users className="w-5 h-5 text-blue-400" strokeWidth={1} />}
      >
        <QuotaUserGroup />
      </AccordionItem>
    </div>
  );
}
